export const OperatorConfigList = [
    { id: "Dream", name:"Dream" },
    { id: "BetFair", name: "BetFair" },
    { id: "Tommy", name: "Tommy" },
    { id: "SportRadar", name: "SportRadar" },
    { id: "RX", name: "RX" },
    { id: "MZ", name: "MZ" },
    { id: "betFairPlus", name: "BetFair Plus" },
    { id: "tommyPlus", name: "Tommy Plus" },
    { id: "srPlus", name: "SportRadar Plus" },
    { id: "rxPlus", name: "RX Plus" },
    { id: "mzPlus", name: "MZ Plus" },
    { id: "signature", name: "Signature" },
    { id: "marketResult", name: "Market Result" },
    { id: "newSession", name: "New Session" },
    { id: "showBalance", name: "Show Balance" },
    { id: "cashout", name: "Cashout" },
    { id: "betupdate", name: "Bet Updates" },
    { id: "exposure", name: "Exposure" },
    { id: "noCommission", name: "No Commission" },
    { id: "isSdk", name: "SDK Operator" },
  ];

  export const EditOperatorConfigList = [
    { id: "betFairPlus", name: "BetFair Plus" },
    { id: "tommyPlus", name: "Tommy Plus" },
    { id: "srPlus", name: "SportRadar Plus" },
    { id: "rxPlus", name: "RX Plus" },
    { id: "mzPlus", name: "MZ Plus" },
    { id: "signature", name: "Signature" },
    { id: "marketResult", name: "Market Result" },
    { id: "newSession", name: "New Session" },
    { id: "showBalance", name: "Show Balance" },
    { id: "cashout", name: "Cashout" },
    { id: "betupdate", name: "Bet Updates" },
    { id: "exposure", name: "Exposure" },
    { id: "noCommission", name: "No Commission" },
    { id: "isSdk", name: "SDK Operator" },
  ];